var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHorizontallyAlign = function SvgHorizontallyAlign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.75h1.25v2.5H2zm6.25 0H9.5v2.5H8.25zm6.25 0h1.25v2.5H14.5zm6.25 0H22v2.5h-1.25zM4.5 18.25V5.75H7v12.5zM10.75 22V2h2.5v20zM17 18.25V5.75h2.5v12.5z"
  })));
};
export default SvgHorizontallyAlign;